import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../adminApi';

export function useCatalogProductImages(productId: number) {
  return useQuery({ queryKey: ['catalog', 'images', productId], queryFn: () => adminApi.getCatalogProductImages(productId), refetchInterval: (query) => query.state.data?.some((photo) => photo.link_processing_status !== 'failed' && (photo.link_image_is_published === false || photo.link_pending_file_id != null)) ? 3000 : false });
}
